import React from 'react'
import { Typography } from '@telavita-core/react-design-kit'

import * as S from './styles'

interface PatientAlreadyHasReservationProps {
  patientFirstName: string
}

export const PatientAlreadyHasReservation = ({
  patientFirstName
}: PatientAlreadyHasReservationProps): JSX.Element => {
  return (
    <>
      <Typography variant='content2' center>
        Este paciente já possui uma reserva.
      </Typography>

      <S.Box>
        <Typography variant='content2' weight='bolder'>
          INFORME AO PACIENTE:
        </Typography>
        
        <Typography variant='content2'>
          {patientFirstName}, para criar uma nova reserva, primeiro você deve cancelar a atual, dentro da sua conta.
        </Typography>
      </S.Box>
    </>
  )
}